module.exports = __webpack_public_path__ + "img/construction-robotics.b4b61b7c.png";